// extracted by mini-css-extract-plugin
export default {"leavesden3":"J5e2V","leavesden4":"z7GhB","shippingLabel":"BnC7B"};